import { useEffect, useRef } from 'react';
import { AudioTrack as IAudioTrack } from 'twilio-video';

interface AudioTrackProps {
    track: IAudioTrack;
}

const AudioTrack: React.FC<AudioTrackProps> = ({ track }) => {
    const audioEl = useRef<HTMLAudioElement>();

    useEffect(() => {
        audioEl.current = track.attach();
        audioEl.current.setAttribute('data-cy-audio-track-name', track.name);
        document.body.appendChild(audioEl.current);
        return () =>
            track.detach().forEach((el) => {
                el.remove();
                el.srcObject = null;
            });
    }, [track]);

    return null;
};

export default AudioTrack;
